import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=1ac3c26f&scoped=true"
import script from "./Course.vue?vue&type=script&setup=true&lang=js"
export * from "./Course.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=1ac3c26f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac3c26f",
  null
  
)

export default component.exports